<template>
  <section class="content">
    <!-- GitHub hint -->
    <div class="row">
      <div class="col-xs-12"></div>
      <div class="clearfix visible-sm-block"></div>
    </div>
    <!--   Profile Details  -->
    <div class="row center-block">
      <div class="col-12">
        <md-card style="border-radius: 5px;">
          <md-card-header>
            <div class="md-title pf-title"><i class="fa fa-user" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Personal Details</div>
            <!-- <input  @change="putIconIntoW3Bucket($event.target.files,profileDetails.profile_image_url)" id="url" name="url" ref="myFiles"  type="file"/>
            <img class="img-thumbnail" :src="profileDetails.profile_image_url === null || profileDetails.profile_image_url === '' ? awsImageFixedUrl + 'default-profile.jpeg' : awsImageFixedUrl + 'user-' + profileDetails.id + '.png'" style="width: 100px;height: 100px;"/>
            <div class="md-title">Change Profile Details</div> -->
          </md-card-header>
          <md-card-content>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="row">
                  <div class="col-md-3 col-lg-3 col-xl-3">
                    <div v-if="this.imageHave" class="image-uploder-empty">
                      <img
                        :src="'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_other/profile/'+this.profileDetails.profile_image_url"
                        class="good-image"
                        style="border-radius: 50%;"
                      />
                      <div @click="changeImage()" class="upload-icon">
                        <i class="material-icons">add_box</i>
                      </div>
                   </div>
                   <div v-if="!this.imageHave" class="settings-page">
                      <div class="text-center">
                        <croppa
                          v-model="croppa1"
                          :quality="1"
                          :width="220"
                          :height="220"
                          placeholder="Click here to upload your Profile"
                          placeholder-color="#5b5b5b"
                          canvas-color="transparent"
                          :placeholder-font-size="12"
                          :show-remove-button="true"
                          accept=".jpeg, .png, .jpg"
                          :file-size-limit="10240000"
                          :prevent-white-space="true"
                          :zoom-speed="6"
                          initial-size="cover"
                          initial-position="center"
                          :disable-drag-and-drop="false"
                          @file-type-mismatch="onFileTypeMismatch"
                          @file-size-exceed="onFileSizeExceed"
                          @mousemove="profileIMG = croppa1.generateDataUrl()"
                          @touchmove="profileIMG = croppa1.generateDataUrl()"
                        ></croppa>
                          <div v-if="profileIMG">
                            <div
                              v-if="!editComplete.img"
                              @click="uploadNow(profileIMG)"
                              class="pro_upload-icon"
                            >
                              <i class="material-icons">archive</i>
                            </div>
                          </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="text-center">
                       <sync-loader :loading="loading" :color="editModalColor"></sync-loader>
                    </div>

                    <!-- <input  @change="putIconIntoW3Bucket($event.target.files,profileDetails.profile_image_url)" id="url" name="url" ref="myFiles"  type="file"/> -->
                  </div>
                  <div class="col-md-9 col-lg-9 col-xl-9">
                    <form class="row-rm-padding">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <div class="col-md-6">
                    <md-field>
                      <label class="lable-fileds">Email</label>
                      <md-input name="email" id="email" v-model="profileDetails.email" readonly/>
                    </md-field>
                  </div>
                  <div class="col-md-6">
                    <md-field>
                      <label class="lable-fileds">Organization</label>
                      <md-input name="email" id="email" v-model="profileDetails.organization_name" readonly/>
                    </md-field>
                  </div>
                  <div class="col-md-2">
                    <md-field :class="getValidationClassProfileDetails('title')">
                      <md-select v-model="profileDetails.title" name="title" id="title" placeholder="Title*">
                        <md-option value="Mr.">Mr</md-option>
                        <md-option value="Mrs.">Mrs</md-option>
                        <md-option value="Mrs.">Miss</md-option>
                        <md-option value="Mrs.">Other</md-option>
                      </md-select>
                      <span class="md-error" v-if="!$v.profileDetails.title.required">The title is required</span>
                      <span class="md-error" v-if="$v.profileDetails.title.required && this.profileDetailsBackendValidation.title.isError">{{this.profileDetailsBackendValidation.title.errorMsg}}</span>
                    </md-field>
                  </div>
                  <div class="col-md-5">
                    <md-field :class="getValidationClassProfileDetails('first_name')">
                      <label class="lable-fileds">First Name</label>
                      <md-input name="first_name" id="first_name" v-model="profileDetails.first_name"/>
                      <span class="md-error" v-if="!$v.profileDetails.first_name.required">The First Name is required</span>
                      <span class="md-error" v-if="$v.profileDetails.first_name.required && this.profileDetailsBackendValidation.first_name.isError">{{this.profileDetailsBackendValidation.first_name.errorMsg}}</span>
                    </md-field>
                  </div>
                  <div class="col-md-5">
                    <md-field :class="getValidationClassProfileDetails('last_name')">
                      <label class="lable-fileds">Last Name</label>
                      <md-input name="last_name" id="last_name" v-model="profileDetails.last_name"/>
                      <span class="md-error" v-if="!$v.profileDetails.last_name.required">The Last Name is required</span>
                      <span class="md-error" v-if="$v.profileDetails.last_name.required && this.profileDetailsBackendValidation.last_name.isError">{{this.profileDetailsBackendValidation.last_name.errorMsg}}</span>
                    </md-field>
                  </div>
                  <div class="col-md-6">
                    <md-field :class="getValidationClassProfileDetails('phone_no')">
                      <label class="lable-fileds">Phone Number</label>
                      <md-input name="phone_no" id="phone_no" v-model="profileDetails.phone_no"/>
                      <span class="md-error" v-if="!$v.profileDetails.phone_no.required">The Phone Number is required</span>
                      <span class="md-error" v-if="$v.profileDetails.phone_no.required && this.profileDetailsBackendValidation.phone_no.isError">{{this.profileDetailsBackendValidation.phone_no.errorMsg}}</span>
                    </md-field>
                  </div>
                  <div class="col-md-6">
                    <md-field :class="getValidationClassProfileDetails('state_id')">
                      <label class="lable-fileds">State</label>
                      <md-select v-model="profileDetails.state_id" name="state_id" id="state_id">
                        <md-optgroup v-for="item in CountryList" v-bind:key="item.id" :label='item.name'>
                          <md-option v-for="item2 in item.states" v-bind:key="item2.id" :value="item.id+','+item2.id">{{item2.name}}</md-option>
                        </md-optgroup>
                      </md-select>
                      <span class="md-error" v-if="!$v.profileDetails.state_id.required">The state_name is required</span>
                      <span class="md-error" v-if="$v.profileDetails.state_id.required && this.profileDetailsBackendValidation.state_id.isError">{{this.profileDetailsBackendValidation.state_id.errorMsg}}</span>
                    </md-field>
                  </div>
                  <!-- <div class="col-md-4">
                    <md-field :class="getValidationClassProfileDetails('country_id')">
                      <md-select v-model="profileDetails.country_id" name="country_id" id="country_id" placeholder="Country*">
                        <md-option v-for="item in countrySelection" v-bind:key="item.id" :value="item.id">
                          {{item.name}}
                        </md-option>
                      </md-select>
                      <span class="md-error" v-if="!$v.profileDetails.country_id.required">The country is required</span>
                      <span class="md-error" v-if="$v.profileDetails.country_id.required && this.profileDetailsBackendValidation.country_id.isError">{{this.profileDetailsBackendValidation.country_id.errorMsg}}</span>
                    </md-field>
                  </div> -->
                  <!-- <div class="col-md-6">
                    <md-field :class="getValidationClassProfileDetails('password')">
                      <label class="lable-fileds">Current password</label>
                      <md-input type="password" name="password" id="password" v-model="profileDetails.password"/>
                      <span class="md-error" v-if="!$v.profileDetails.password.required">The current password is required</span>
                      <span class="md-error" v-if="$v.profileDetails.password.required && this.profileDetailsBackendValidation.password.isError">{{this.profileDetailsBackendValidation.password.errorMsg}}</span>
                    </md-field>
                  </div> -->
                </div>
              </div>
            </form>
                  </div>
                </div>
              </div>
            </div>

          </md-card-content>
          <md-card-actions>
            <md-button class="btn primary-btn-my md-raised md-primary" @click="validateSubmissionProfileDetails">Save</md-button>
<!--            <md-button class="md-accent">Cancel</md-button>-->
          </md-card-actions>
        </md-card>

        <!-- <md-card style="border-radius: 5px;;margin-top: 30px;">
          <md-card-header>
            <div class="md-title pf-title"><i class="fa fa-briefcase" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Other Details</div>
          </md-card-header>
          <md-card-content>
            <form class="row-rm-padding">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                    <div class="col-md-4">
                      <md-field :class="getValidationClassWorkingDetails('industry_id')">
                        <md-select v-model="workingDetails.industry_id" name="industry_id" id="industry_id" placeholder="Industry*">
                          <md-option v-for="item in industrySelection" v-bind:key="item.id" :value="item.id">
                            {{item.name}}
                          </md-option>
                        </md-select>
                        <span class="md-error" v-if="!$v.workingDetails.industry_id.required">The industry is required</span>
                        <span class="md-error" v-if="$v.workingDetails.industry_id.required && this.workingDetailsBackendValidation.industry_id.isError">{{this.workingDetailsBackendValidation.industry_id.errorMsg}}</span>
                      </md-field>
                    </div>
                    <div class="col-md-4">
                      <md-field :class="getValidationClassWorkingDetails('organization')">
                        <label>Company / Organization</label>
                        <md-input v-model="workingDetails.organization" name="organization" id="organization" autocomplete="organization" placeholder="Organization"/>
                        <span class="md-error" v-if="!$v.workingDetails.organization.required">The organization is required</span>
                        <span class="md-error" v-if="$v.workingDetails.organization.required && this.workingDetailsBackendValidation.organization.isError">{{this.workingDetailsBackendValidation.organization.errorMsg}}</span>
                      </md-field>
                    </div>
                    <div class="col-md-4">
                      <md-field :class="getValidationClassWorkingDetails('distributer')">
                        <label>Distributor</label>
                        <md-input v-model="workingDetails.distributer" name="distributor" id="distributor" autocomplete="distributor" placeholder="Distributor"/>
                        <span class="md-error" v-if="!$v.workingDetails.distributer.required">The distributor is required</span>
                        <span class="md-error" v-if="$v.workingDetails.distributer.required && this.workingDetailsBackendValidation.distributer.isError">{{this.workingDetailsBackendValidation.distributer.errorMsg}}</span>
                      </md-field>
                    </div>
                  <div class="col-md-6">
                    <md-field :class="getValidationClassWorkingDetails('wk_password')">
                      <label class="lable-fileds">Current password</label>
                      <md-input type="password" name="wk_password" id="wk_password" v-model="workingDetails.password"/>
                      <span class="md-error" v-if="!$v.workingDetails.password.required">The current password is required</span>
                      <span class="md-error" v-if="$v.workingDetails.password.required && this.workingDetailsBackendValidation.password.isError">{{this.workingDetailsBackendValidation.password.errorMsg}}</span>
                    </md-field>
                  </div>
                  </div>
              </div>
            </form>
          </md-card-content>
          <md-card-actions>
            <md-button class="btn primary-btn-my md-raised md-primary" @click="validateSubmissionWorkingDetails">Save</md-button>
          </md-card-actions>
        </md-card> -->

        <md-card style="border-radius: 5px;;margin-top: 30px;">
          <md-card-header>
            <div class="md-title pf-title"><i class="fa fa-bell" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Notification Settings</div>
          </md-card-header>
          <md-card-content>
            <form class="row-rm-padding">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                    <p class="notify-titlee">Push Notifications</p>
                    <div class="row" style="padding-left: 20px;">
                        <div class="col-md-12">
                        <md-checkbox class="notifi-check" v-model="notifications.product_notifi">Product Notification
                          <p style="color: #8c8c8c;">Get notified when new products are added on to the platform</p>
                        </md-checkbox>
                        
                      </div>
                      <div class="col-md-12">
                        <md-checkbox class="notifi-check" v-model="notifications.document_notifi">Documents Notification
                          <p style="color: #8c8c8c;">Get notified when new documents are added on to the platform</p>
                        </md-checkbox>
                      </div>
                      <div class="col-md-12">
                        <md-checkbox class="notifi-check" v-model="notifications.video_notifi">Video Notification
                          <p style="color: #8c8c8c;">Get notified when new videos are added on to the platform</p>
                        </md-checkbox>
                      </div>
                    </div>
                    <br>
                    <p class="notify-titlee">Email Notifications</p>
                    <div class="row" style="padding-left: 20px;">
                      <div class="col-md-12">
                      <md-checkbox class="notifi-check" v-model="notifications.product_email">Product Email Notification
                        <p style="color: #8c8c8c;">Get notified via email when new products are added on to the platform</p>
                      </md-checkbox>
                    </div>
                    </div>
                  </div>
              </div>
            </form>
          </md-card-content>
          <md-card-actions>
            <md-button class="btn primary-btn-my md-raised md-primary" @click="updateNotifications">Save</md-button>
          </md-card-actions>
        </md-card>

        <md-card style="border-radius: 5px;;margin-top: 30px;">
          <md-card-header>
            <div class="md-title pf-title"><i class="fa fa-lock" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;Change Password</div>
          </md-card-header>
          <md-card-content>
            <form class="row-rm-padding">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field :class="getValidationClassPassChange('scu_password')">
                    <label class="lable-fileds">Current password</label>
                    <md-input type="password" name="scu_password" id="scu_password" v-model="securityDetails.password"/>
                    <span class="md-error" v-if="!$v.securityDetails.password.required">The your old password is required</span>
                    <span class="md-error" v-if="$v.securityDetails.password.required && this.securityDetailsBackendValidation.password.isError">{{this.securityDetailsBackendValidation.password.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClassPassChange('new_password')">
                    <label class="lable-fileds">New password</label>
                    <md-input type="password" name="new_password" id="new_password" v-model="securityDetails.new_password"/>
                    <span class="md-error" v-if="!$v.securityDetails.new_password.required">The new Password is required</span>
                    <span class="md-error" v-if="$v.securityDetails.new_password.required && this.securityDetailsBackendValidation.new_password.isError">{{this.securityDetailsBackendValidation.new_password.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClassPassChange('confirm_password')">
                    <label class="lable-fileds">Confirm password</label>
                    <md-input type="password" name="confirm_password" id="confirm_password" v-model="securityDetails.confirm_password"/>
                    <span class="md-error" v-if="!$v.securityDetails.confirm_password.required">The confirm password is required</span>
                    <span class="md-error" v-if="$v.securityDetails.confirm_password.required && this.securityDetailsBackendValidation.confirm_password.isError">{{this.securityDetailsBackendValidation.confirm_password.errorMsg}}</span>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>
          <md-card-actions>
            <md-button class="btn primary-btn-my md-raised md-primary" @click="validateSubmissionChngPForm" >Save</md-button>
<!--            <md-button class="md-accent">Cancel</md-button>-->
          </md-card-actions>
        </md-card>
      </div>
    </div>

  </section>
</template>
<script>
  var SyncLoader = require('vue-spinner/src/SyncLoader')
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import api from '../../../api'
  import $ from 'jquery'
  import AWS from 'aws-sdk'
  AWS.config.region = 'us-east-2' // 1. Enter your region

  AWS.config.region = 'ap-southeast-1' // 1. Enter your region

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'ap-southeast-1:d3a76794-ef80-4000-a846-afb95dc782f3' // 2. Enter your identity pool
  })

  AWS.config.credentials.get(function(err) {
    if (err) alert(err)
  })

  var bucketName = 'smartapprcp' // Enter your bucket name
  var bucket = new AWS.S3({
    params: {
      Bucket: bucketName
    }
  })
  export default {
    name: 'UserProfileView',
    mixins: [validationMixin],
    components: {
      'SyncLoader': SyncLoader
    },
    data() {
      return {
        editModalColor: '#FECD2F',
        loading: false,
        imageHave: false,
        croppa1: {},
        editComplete: {
          img: false
        },
        profileIMG: '',
        awsImageFixedUrl: 'https://smartapprcp.s3.ap-southeast-1.amazonaws.com/rcp_other/user-profile-pictures/',
        countrySelection: [],
        industrySelection: [],
        CountryList: [],
        isUploadingImage: false,
        isUploadImage: false,
        isUploadedImage: false,
        isUploadErrorImage: false,
        notifications: {
          product_notifi: false,
          product_email: false,
          document_notifi: false,
          video_notifi: false
        },
        profileDetails: {
          id: null,
          title: null,
          first_name: null,
          last_name: null,
          email: null,
          phone_no: null,
          country_id: null,
          profile_image_url: null,
          organization_name: null,
          state_id: null
        },
        // workingDetails: {
        //   organization: null,
        //   distributer: null,
        //   industry_id: null,
        //   password: null
        // },
        securityDetails: {
          id: null,
          password: null,
          new_password: null,
          confirm_password: null
        },
        profileDetailsBackendValidation: {
          title: {
            isError: false,
            errorMsg: ''
          },
          first_name: {
            isError: false,
            errorMsg: ''
          },
          last_name: {
            isError: false,
            errorMsg: ''
          },
          phone_no: {
            isError: false,
            errorMsg: ''
          },
          country_id: {
            isError: false,
            errorMsg: ''
          },
          state_id: {
            isError: false,
            errorMsg: ''
          }
        },
        // workingDetailsBackendValidation: {
        //   organization: {
        //     isError: false,
        //     errorMsg: ''
        //   },
        //   distributer: {
        //     isError: false,
        //     errorMsg: ''
        //   },
        //   password: {
        //     isError: false,
        //     errorMsg: ''
        //   },
        //   industry_id: {
        //     isError: false,
        //     errorMsg: ''
        //   }
        // },
        securityDetailsBackendValidation: {
          password: {
            isError: false,
            errorMsg: ''
          },
          new_password: {
            isError: false,
            errorMsg: ''
          },
          confirm_password: {
            isError: false,
            errorMsg: ''
          }
        }
      }
    },
    validations: {
      profileDetails: {
        title: {
          required
        },
        first_name: {
          required
        },
        last_name: {
          required
        },
        phone_no: {
          required
        },
        country_id: {
          required
        },
        state_id: {
          required
        }
      },
      // workingDetails: {
      //   organization: {
      //     required
      //   },
      //   distributer: {
      //     // required
      //   },
      //   password: {
      //     // required
      //   },
      //   industry_id: {
      //     required
      //   }
      // },
      securityDetails: {
        password: {
          required
        },
        new_password: {
          required
        },
        confirm_password: {
          required
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.setCountryDropDownData()
        this.setIndustryDropDownData()
        this.getProfileDetails()
        this.getCountryList()
      })
    },
    methods: {
      updateNotifications() {
        api.request('post', '/customer/profile/notification', this.notifications)
          .then(response => {
            var ref = this
            if (response.status === 200) {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'success', title: 'Record updated successfully'})
              ref.getProfileDetails()
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
          })
      },
      getCountryList() {
        api
          .request('get', '/admin/country/select')
          .then(response => {
            this.CountryList = response.data.result
          })
      },
      uploadNow(upmage) {
        this.editComplete.img = true
        this.loading = true
        setTimeout(() => this.uploadImageS3(upmage), 500)
      },
      uploadImageS3(base64String) {
        var ref = this
        function urltoFile(url, filename, mimeType) {
          return fetch(url)
            .then(function(res) {
              return res.arrayBuffer()
            })
            .then(function(buf) {
              return new File([buf], filename, { type: mimeType })
            })
        }
        var profilePicName = 'user-' + this.profileDetails.id + '.png'
        var path = 'rcp_other/profile/' + profilePicName

        this.profileDetails.profile_image_url = profilePicName
        urltoFile(base64String).then(function(file) {
          var objKey = path
          var params = {
            Key: objKey,
            ContentType: 'image/png',
            Body: file,
            ACL: 'public-read'
          }
          bucket.putObject(params, function(err, data) {
            if (err) {
              console.log(err)
            } else {
              ref.$cookie.set('proImg', profilePicName, 1)
              ref.loading = false
              ref.imageHave = true
              ref.saveUserImgUrlDatabase()
            }
          })
        })
        // setTimeout(() => this.uploadImageDB(), 8000)
      },
      saveUserImgUrlDatabase() {
        api.request('get', '/customer/profileImageUrlUpdate')
          .then(response => {
            if (response.status === 200) {
              window.location.reload()
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      onFileTypeMismatch(file) {
        alert('Invalid file type. Please choose a jpeg or png file.')
      },
      onFileSizeExceed(file) {
        alert('File size exceeds. Please choose a file smaller than 10MB.')
      },
      changeImage() {
        this.imageHave = false
        this.profileDetails.profile_image_url = null
      },
      setCountryDropDownData() {
        api.request('get', '/admin/country/select')
          .then(response => {
            this.countrySelection = response.data.result
          })
      },
      setIndustryDropDownData() {
        api.request('get', '/admin/industries/select')
        .then(response => {
          this.industrySelection = response.data.result
        })
      },
      getValidationClassProfileDetails(fieldName) {
        const field = this.$v.profileDetails[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      // getValidationClassWorkingDetails(fieldName) {
      //   const field = this.$v.workingDetails[fieldName]

      //   if (field) {
      //     return {
      //       'md-invalid': field.$invalid && field.$dirty
      //     }
      //   }
      // },
      getValidationClassPassChange(fieldName) {
        const field = this.$v.securityDetails[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      getProfileDetails() {
        api.request('get', '/customer/profile')
          .then(response => {
            if (response.status === 200) {
              // this.workingDetails = response.data.result
              this.profileDetails = response.data.result
              response.data.result.product_notifi === 1 ? this.notifications.product_notifi = true : this.notifications.product_notifi = false
              response.data.result.product_email === 1 ? this.notifications.product_email = true : this.notifications.product_email = false
              response.data.result.video_notifi === 1 ? this.notifications.video_notifi = true : this.notifications.video_notifi = false
              response.data.result.document_notifi === 1 ? this.notifications.document_notifi = true : this.notifications.document_notifi = false
              this.profileDetails.state_id = this.profileDetails.country_id + ',' + this.profileDetails.state_id
              if (this.profileDetails.profile_image_url === null) {
                this.imageHave = false
              } else {
                this.imageHave = true
              }
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      },
      validateSubmissionProfileDetails() {
        if (this.profileDetails.state_id != null) {
          var arr = this.profileDetails.state_id.split(',')
          this.profileDetails.country_id = arr[0]
          this.profileDetails.state_id = arr[1]
        }
        this.$v.profileDetails.$touch()
        // this.submitProfileDetails(this.$v.profileDetails.$model)
        if (!this.$v.profileDetails.$invalid) {
          // eslint-disable-next-line no-undef
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, update my profile details!'
          }).then((result) => {
            if (result.value) {
              this.submitProfileDetails(this.$v.profileDetails.$model)
            }
          })
        }
      },
      // validateSubmissionWorkingDetails() {
      //   this.$v.workingDetails.$touch()
      //   if (!this.$v.workingDetails.$invalid) {
      //     // eslint-disable-next-line no-undef
      //     Swal.fire({
      //       title: 'Are you sure?',
      //       text: "You won't be able to revert this!",
      //       icon: 'warning',
      //       showCancelButton: true,
      //       confirmButtonColor: '#3085d6',
      //       cancelButtonColor: '#d33',
      //       confirmButtonText: 'Yes, update my profile details!'
      //     }).then((result) => {
      //       if (result.value) {
      //         this.submitWorkingDetails(this.$v.workingDetails.$model)
      //       }
      //     })
      //   }
      // },
      validateSubmissionChngPForm() {
        this.$v.securityDetails.$touch()
        if (!this.$v.securityDetails.$invalid) {
          // eslint-disable-next-line no-undef
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, change password!'
          }).then((result) => {
            if (result.value) {
              this.changePassword(this.$v.securityDetails.$model)
            }
          })
        }
      },
      submitProfileDetails(data) {
        api.request('post', '/customer/profile/profile', data)
          .then(response => {
            var ref = this
            console.log(response)
            if (response.status === 200) {
              // this.form = response.data.result
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.profileDetailsBackendValidation.hasOwnProperty(key.toString())) {
                    ref.profileDetailsBackendValidation[key.toString()].isError = true
                    ref.profileDetailsBackendValidation[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                  }
                })
              } else if (response.data.result.status === 'success') {
                this.getProfileDetails()
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else if (response.data.result.status === 'error') {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },
      submitWorkingDetails(data) {
        api.request('post', '/customer/profile/working', data)
          .then(response => {
            var ref = this
            if (response.status === 200) {
              // this.form = response.data.result
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.workingDetailsBackendValidation.hasOwnProperty(key.toString())) {
                    ref.workingDetailsBackendValidation[key.toString()].isError = true
                    ref.workingDetailsBackendValidation[key.toString()].errorMsg = valueObj[0]
                    if (key.toString() === 'password') {
                      $('#wk_password').parent().addClass('md-invalid')
                    } else {
                      $('#' + key.toString()).parent().addClass('md-invalid')
                    }
                  }
                })
              } else if (response.data.result.status === 'success') {
                this.getProfileDetails()
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else if (response.data.result.status === 'error') {
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.status.message})
              }
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },
      changePassword(data) {
        api.request('post', '/customer/profile/security', data)
          .then(response => {
            var ref = this
            if (response.status === 200) {
              if (response.data.error) {
                $.each(response.data.error, function (key, valueObj) {
                  if (ref.securityDetailsBackendValidation.hasOwnProperty(key.toString())) {
                    ref.securityDetailsBackendValidation[key.toString()].isError = true
                    ref.securityDetailsBackendValidation[key.toString()].errorMsg = valueObj[0]
                    if (key.toString() === 'password') {
                      $('#scu_password').parent().addClass('md-invalid')
                    } else {
                      $('#' + key.toString()).parent().addClass('md-invalid')
                    }
                  }
                })
              } else if (response.data.result.status === 'success') {
                this.securityDetails.password = null
                this.securityDetails.new_password = null
                this.securityDetails.confirm_password = null
                // eslint-disable-next-line no-undef
                this.$v.$reset()
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'success', title: 'Record updated successfully'})
              } else if (response.data.result.status === 'error') {
                this.securityDetails.password = null
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      }
      // putIconIntoW3Bucket(files, existingUrl = null) {
      //   if (files) {
      //     var ref = this
      //     ref.isUploadingImage = true
      //     ref.isUploadImage = false
      //     ref.isUploadedImage = false
      //     ref.isUploadErrorImage = false
      //     let file = files[0]
      //     var profilePicName = 'user-' + ref.profileDetails.id + '.png'
      //     if (existingUrl != null) {
      //       profilePicName = existingUrl
      //     }
      //     var params = {
      //       Key: profilePicName,
      //       ContentType: file.type,
      //       Body: file,
      //       ACL: 'public-read'
      //     }
      //     bucket.putObject(params, function (err, data) {
      //       if (err) {
      //         ref.isUploadingImage = false
      //         ref.isUploadImage = false
      //         ref.isUploadedImage = false
      //         ref.isUploadErrorImage = true
      //       // eslint-disable-next-line no-undef
      //         toast.fire({icon: 'error', title: err})
      //       } else {
      //         ref.isUploadingImage = false
      //         ref.isUploadImage = false
      //         ref.isUploadedImage = true
      //         ref.isUploadErrorImage = false
      //         ref.profileDetails.profile_image_url = profilePicName
      //       }
      //     })
      //   } else {
      //     ref.isUploadingImage = false
      //     ref.isUploadImage = false
      //     ref.isUploadedImage = false
      //     ref.isUploadErrorImage = true
      //   }
      // }
    }
  }
</script>
<style>
  /* layout.css Style */
  .upload-drop-zone {
    height: 100px;
    border-width: 2px;
    margin-bottom: 20px;
  }

  /* skin.css Style*/
  .upload-drop-zone {
    color: #ccc;
    border-style: dashed;
    border-color: #ccc;
    line-height: 100px;
    text-align: center
  }

  .upload-drop-zone.drop {
    color: #222;
    border-color: #222;
  }


  div.fileinputs {
    position: relative;
  }

  div.fakefile {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
  }

  input.file {
    position: relative;
    text-align: right;
    -moz-opacity: 0;
    filter: alpha(opacity:0);
    opacity: 0;
    z-index: 2;
  }

  /* .login-page, .register-page {
    background: #d2d6de !important;
  } */

  logo {
    font-size: 35px !important;
    text-align: center !important;
    margin-bottom: 25px !important;
    font-weight: 300 !important;
  }

  .login-logo a, .register-logo a {
    color: #444 !important;

  }

  b, strong {
    font-weight: 700 !important;
  }
</style>



// WEBPACK FOOTER //
// UserProfileView.vue?0f42643c